import { path } from "../../api";
import { restClient } from "../../utils/restClient";

export default {
  namespaced: true,
  actions: {
    async get() {
      const { data } = await restClient(
        path.admin.autoApprovalRules.base,
        "GET"
      );
      return data;
    },
    async create(_, payload) {
      const { data } = await restClient(
        path.admin.autoApprovalRules.base,
        "POST",
        payload
      );
      return data;
    },
    async update(_, { id, ...payload }) {
      const { data } = await restClient(
        path.admin.autoApprovalRules.single(id),
        "PUT",
        payload
      );
      return data;
    },
    async getProviderUsage() {
      const { data } = await restClient(
        path.admin.autoApprovalRules.providerUsage,
        "GET"
      );
      return data;
    },
  },
};
